import React from 'react';

import '../../styles/encabezadoSeccion.css'
/**
 * Componente que contiene los elementos relacionados a encabezados de sección
 * @param {Object} param0 Recibe un objeto con el titulo inicial, el titulo final(puede ser null) y la ruta de la imagen a mostrar
 * @returns Component Devuelve el componente con los elementos requeridos
 */
const EncabezadoSeccion = ({tituloInicial,tituloFinal,imgSource,cantidad}) => {  
    
    return(
        <>
            <h2 className='titulo_verde'>{tituloInicial} <span>{tituloFinal}</span> <span className='cantidad_pacientes'>{cantidad}</span></h2>
            <div className='icono_titulo'>
                <img src={imgSource} title="Mac" alt="Mac" height="35px" />
            </div>
        </>
    )
}

export default EncabezadoSeccion;